import { useRef } from 'react';
import { MdOutlinePrint } from 'react-icons/md';
import { BatchCollect } from 'types';
import { Print, PrintTemplate, Text } from 'components';
import { formatTimestamp } from 'helpers';
import { FontSize, FontWeight } from 'commons';
import * as S from './styles';

interface Props {
  lastBatchCollect: BatchCollect;
}

export function BatchCollectCard({ lastBatchCollect }: Props) {
  const togglePrintRef = useRef<HTMLLabelElement>(null);

  function togglePrint() {
    const { current } = togglePrintRef;

    if (current) {
      current.click();
    }
  }

  const { carrier, consignments, cpf, date, name } = lastBatchCollect;
  const { day, month, hour, minute } = formatTimestamp(date);

  return (
    <S.Card onClick={togglePrint}>
      <S.InfoWrapper>
        <S.DateWrapper>
          <Text>Última coleta</Text>
          <Text size={FontSize.font10} weight={FontWeight.medium}>
            {day}/{month} ás {hour}:{minute}
          </Text>
        </S.DateWrapper>

        <Text
          className="carrier-name"
          size={FontSize.font16}
          weight={FontWeight.bold}
        >
          {name}
        </Text>
      </S.InfoWrapper>

      <Print
        linkTemplate
        Template={
          <PrintTemplate.CollectReceipt
            name={name}
            cpf={cpf}
            collector={carrier}
            batchCollectConsignments={consignments}
            collectionDate={date}
          />
        }
      >
        <label hidden ref={togglePrintRef} />
      </Print>

      <S.PrintLabel>
        <MdOutlinePrint size={16} />
        <Text size={FontSize.font10} weight={FontWeight.medium}>
          Imprimir
        </Text>
      </S.PrintLabel>
    </S.Card>
  );
}
